"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchSubjectImpl = void 0;
const branch_1 = require("./branch");
const emitter_1 = require("./emitter");
class BranchSubjectImpl {
    data = {};
    emitter;
    observers = [];
    constructor() {
        this.emitter = new emitter_1.Emitter();
    }
    getState() {
        return Object.values(this.data);
    }
    getEventListener() {
        return this.emitter;
    }
    set(branch) {
        if (this.data[branch.id]) {
            return;
        }
        this.data[branch.id] = branch;
        this.notify();
        const e = {
            type: branch_1.BranchSubjectEventTypes.ADD,
            value: branch,
        };
        const event = new CustomEvent(e.type, { detail: e });
        this.emitter.dispatchEvent(event);
    }
    attach(observer) {
        this.observers.push(observer);
    }
    notify() {
        this.observers.forEach(o => o.update());
    }
}
exports.BranchSubjectImpl = BranchSubjectImpl;
